import { connect } from 'react-redux';
import Loader from './Loader';

const mapStateToProps = state => ({
  show: state.appModal.isLoading,
  loadingText: state.appModal.loadingText
});

export default connect(mapStateToProps)(Loader);
